// docs/129 §7.1 — which 24 px hero-kit icon draws an item, wherever it is drawn. Every catalogue piece
// (`items.gen.json`, ids 1000 and up) has its own icon, and every hand-authored piece of `fk_grammar::ITEMS`
// (ids 100–192: starter kits, backgrounds' gear, the old salve and tonic) borrows one catalogue piece's art
// (`baseItemArt.ts`); `itemArt(def)` resolves both. A def that is neither is read by its name; failing that
// it has no icon and the caller draws a glyph. No item is drawn from the Oryx sheet any more.
import { itemArt } from './itemArt';

/** A piece the tables don't know, read by its name (first match wins) → the hand-authored def it looks like. */
const BY_NAME: ReadonlyArray<readonly [RegExp, number]> = [
  [/crossbow/, 106], [/bow/, 105], [/axe|hatchet/, 101], [/mace|hammer|club/, 102], [/dagger|knife/, 103], [/spear|pike|glaive/, 104],
  [/staff/, 107], [/wand|rod/, 108], [/sword|blade|sabre/, 100], [/tower/, 113], [/shield|buckler/, 111], [/focus|orb/, 114],
  [/great ?helm/, 132], [/helm|crown|hat/, 131], [/cap|hood/, 130], [/plate/, 123], [/chain|mail/, 122], [/leather/, 121], [/cloth|robe/, 120],
  [/cape|cloak|mantle/, 140], [/gauntlet/, 171], [/glove|wrap/, 170], [/boot|shoe/, 180], [/ring/, 150], [/amulet/, 190], [/pendant|locket/, 191],
  [/torc/, 192], [/candle/, 152], [/charm/, 151], [/pouch/, 154], [/salve|balm/, 160], [/tonic|potion|draught|flask/, 161], [/smoke/, 162], [/scroll|letter|map/, 163],
];

/** The URL of the 24 px icon that draws `def` (by `name` when the def has no art), or `undefined` (draw a glyph). */
export function itemIconUrl(def: number, name = ''): string | undefined {
  const own = itemArt(def);
  if (own) return own.icon;
  const n = name.toLowerCase();
  const hit = n ? BY_NAME.find(([re]) => re.test(n)) : undefined;
  return hit ? itemArt(hit[1])?.icon : undefined;
}

/** The interface draws an icon at whole multiples of 24 px: a frame sized for an old 16 px sprite at
 *  `scale` 1/2/3/4 (16/32/48/64 px) holds the 24 px icon at 1/1/2/3 (docs/129 §3.1). */
export const ICON_SCALE = { 1: 1, 2: 1, 3: 2, 4: 3 } as const;
export const iconPx = (scale: 1 | 2 | 3 | 4): number => 24 * ICON_SCALE[scale];
